import { render, staticRenderFns } from "./ShareSuccessSnackbar.vue?vue&type=template&id=02313c2d"
import script from "./ShareSuccessSnackbar.vue?vue&type=script&lang=ts"
export * from "./ShareSuccessSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports